import api from 'base/utils/api';
import { IPostSubscribeData, IPostSubscribeVariantData } from 'mod/subscribe/interface';

export function postSubscribe(data: IPostSubscribeData): Promise<void> {
    return api.post('/web/activity/subscribe', {
        data: {
            ...data,
            type: data.type || 'common'
        }
    });
}

export function postSubscribeVariant(data: IPostSubscribeVariantData): Promise<void> {
    return api.post('/web/subscribe/variant/arrival', { data });
}